<page-title [title]="title"></page-title>
<p class="instructions">
  Navegue pelas abas para visualizar os usuários. Clique em um cartão para ver mais detalhes.
</p>

<mat-tab-group class="custom-tab-group">
  <!-- Usuários Ativos -->
  <mat-tab label="Ativos">
    <ng-container *ngIf="organizationUsers.length > 0; else noActiveUsers">
      <mat-card
        class="user-card"
        (click)="openOrganizationUserDetails(user)"
        *ngFor="let user of activeOrganizationUsers"
      >
        <img [src]="defaultPatientPhoto" alt="Avatar" class="user-avatar" />
        <div class="user-details">
          <p class="user-name"><strong>Nome:</strong> {{ user.name }}</p>
          <p class="user-email"><strong>Email:</strong> {{ user.email }}</p>
          <p class="user-date"><strong>Data de criação:</strong> {{ layout.dateFormat(user.createdDate) }}</p>
        </div>
      </mat-card>
    </ng-container>
    <ng-template #noActiveUsers>
      <div class="empty-message">
        Nenhum sub-usuário ativo encontrado.
      </div>
    </ng-template>
  </mat-tab>

  <!-- Usuários Inativos -->
  <mat-tab label="Inativos">
    <ng-container *ngIf="organizationUsers.length > 0; else noInactiveUsers">
      <mat-card
        class="user-card"
        (click)="openOrganizationUserDetails(user)"
        *ngFor="let user of inactiveOrganizationUsers"
      >
        <img [src]="user.avatar" alt="Avatar" class="user-avatar" />
        <div class="user-details">
          <p class="user-name"><strong>Nome:</strong> {{ user.name }}</p>
          <p class="user-email"><strong>Email:</strong> {{ user.email }}</p>
          <p class="user-date"><strong>Data de criação:</strong> {{ layout.dateFormat(user.createdDate) }}</p>
        </div>
      </mat-card>
    </ng-container>
    <ng-template #noInactiveUsers>
      <div class="empty-message">
        Nenhum sub-usuário inativo encontrado.
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>

<div class="actions">
  <button
    mat-flat-button
    color="primary"
    (click)="openOrganizationUserRegistration()"
    [disabled]="loading"
  >
    Cadastrar
  </button>
</div>
